(ns quuppa.peweb.peinfo-subs
  (:require [clojure.string :as str]
            [quuppa.peweb.peinfo-utils :as pe-utils]
            [re-frame.core :as rf :refer [reg-sub subscribe]]
            [re-frame.db :as rf-db]
            [quuppa.utils :as utils]
            [quuppa.re-frame-utils :as rf-utils]
            [clojure.string :as s]
            ["@js-joda/core" :as js-joda :refer [LocalTime ZoneOffset]]))

(reg-sub
  ::qpes
  (fn [db _]
    (-> db :qpes)))

(reg-sub
  ::qpe-instance
  :<- [::qpes]
  (fn [qpes [_ qpe-identity]]
    (get qpes qpe-identity)))

(reg-sub
  :app-id
  (fn [db _]
    (-> db :app-id)))

(defn qpe-instance-input
  "Simple reg-sub input function that takes the first
  event parameter and uses that as qpe-indentity"
  [[_ qpe-identity]]
  (subscribe [::qpe-instance qpe-identity]))

;; Used through qpe-subscribe, which adds the qpe-identity as
;; first parameter.
(rf-utils/reg-recursive-sub :qpe/data [::qpes])

(reg-sub
  ::data-root
  (fn [db _]
    db))

(rf-utils/reg-recursive-sub :data [::data-root])

;; TODO: Remove any simple get-in subs

(reg-sub
  :qpe/controller-state
  (fn sub-qpe-controller-state
    [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :controller-state])))

(reg-sub
  :qpe/project-state
  (fn sub-qpe-controller-state
    [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :project-state])))

(reg-sub
  :qpe/system-status
  (fn sub-qpe-system-status
    [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :system-status])))

(reg-sub
  ::controller-state-messages
  (fn sub-controller-state-messages
    [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :controller-state :messages])))

(reg-sub
  ::controller-ui-messages
  (fn sub-controller-ui-messages
    [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :controller-ui :messages])))

(reg-sub
  :controller-ui/messages
  (fn sub-input-controller-ui-messages
    [[_ qpe-identity]]
    [(rf/subscribe [::controller-state-messages qpe-identity])
     (rf/subscribe [::controller-ui-messages qpe-identity])])
  (fn sub-controller-ui-messages
    [[messages message-states] [_ _qpe-identity]]
    ;; NOTE perhaps this too roundabout way of doing, we could just modify the controller state directly
    ;; and simply dissoc those messages from it that the user wants closed
    (let [displayed-message-keys (for [[k v] message-states
                                       :when (not (:closed? v))]
                                   k)
          displayed-messages (select-keys messages displayed-message-keys)]
      (map (fn [e]
             (assoc (val e) :id (key e)))
           displayed-messages))))

(defn level-n [l]
  ({"ERROR" 5
    "WARN" 4
    "INFO" 3
    "TRACE" 2} l))

(rf/reg-sub
  :logging/filtered-log-files
  (fn [[_ qpe-identity]]
    [(rf/subscribe [:qpe/data qpe-identity :logfile-list])
     (rf/subscribe [:qpe/data qpe-identity :ui :log-filters])])
  (fn [[files {:keys [level start-date end-date]}] _]
    (let [filter-level-n (level-n level)
          level-filter (if filter-level-n
                         (filter (fn [file]
                                   (>= (level-n (:max-level file)) filter-level-n)))
                         identity)
          ;; Convert LocalDates to Instants
          start-date (when start-date
                       (-> start-date
                           (.atStartOfDay (.-UTC ZoneOffset))
                           (.toInstant)))
          ;; Compare against end of selected day
          end-date (when end-date
                     (-> end-date
                         (.atTime (.-MAX LocalTime))
                         (.toInstant (.-UTC ZoneOffset))))
          date-filter (if (or start-date end-date)
                        (filter (fn [file]
                                  (and (or (nil? start-date)
                                           (.isAfter (:last-modified file) start-date))
                                       (or (nil? end-date)
                                           (.isBefore (:last-modified file) end-date)))))
                        identity)]
      (sort-by :last-modified (into [] (comp level-filter date-filter) files)))))

(rf/reg-sub
  :qpe/logfile-content
  (fn [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :logfile-content])))

(rf/reg-sub
  :qpe/current-rolling-log-file
  (fn [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :current-rolling-log-file])))

(rf/reg-sub
  :qpe/output-data-files-metadata
  (fn [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :output-data-files-metadata])))

(rf/reg-sub
  :qpe/binarylog-files-metadata
  (fn [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :binarylog-files-metadata])))

(rf/reg-sub
  :qpe/data-player-files-metadata
  (fn [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :data-player-files-metadata])))

(reg-sub
  :current-project/info
  (fn sub-current-project-info
    [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :current-project])))

(reg-sub
  :current-project/license
  (fn sub-current-project-license
    [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :current-project-license])))

(reg-sub
  :qpe/server-info
  (fn sub-qpe-server-info
    [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :server-info])))

(reg-sub
  :project-ui/state
  (fn sub-project-ui-state
    [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :project-ui])))

(reg-sub
  :controller-ui/state-flags
  (fn sub-controller-ui-state-flags
    [db [_ qpe-identity & path]]
    (get-in db (apply conj [:qpes qpe-identity :controller-ui :state-flags] path))))

(reg-sub
  :controller-ui/file-sync-control-disabled?
  (fn [[_ qpe-identity]]
    [rf-db/app-db
     (subscribe [:controller-ui/state-flags qpe-identity :req-file-sync])])
  (fn sub-controller-ui-file-sync-control-disabled?
    [[db file-sync-requested?] [_ qpe-identity]]
    ;; avoid making any complex logic in subscriptions, but in this case it's all derived
    ;; adapted from disable state logic in previous qpe's index.jsp
    (let [license-not-set? (empty? (get-in db [:qpes qpe-identity :controller-state :license-key]))
          file-sync-running? (get-in db [:qpes qpe-identity :controller-state :file-sync-running?])]
      ;; NOTE: We are not checking the `file-sync-disabled?` status here,
      ;;       because this button exposes a manual control and calls `forceFilesync` ultimately at the qpe's end.
      (or license-not-set? file-sync-running? file-sync-requested?))))

(reg-sub
  :qpe/desired-logging-output-config
  (fn desired-logging-output-config
    [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :desired-logging-output-config])))

(reg-sub
  :current-project/tag-map
  qpe-instance-input
  (fn sub-current-project-tag-map
    [qpe-instance _]
    (-> qpe-instance :current-project :tag-map)))

(reg-sub
  :current-project/tag-locations
  qpe-instance-input
  (fn sub-current-project-tag-map
    [qpe-instance _]
    (-> qpe-instance :current-project :tag-locations)))

(reg-sub
  :current-project/tag
  (fn [[_ qpe-identity]]
    (subscribe [:current-project/tag-map qpe-identity]))
  (fn [tag-map [_id _qpe-identity tag-id]]
    (get tag-map tag-id)))

(reg-sub
  :current-project/tag-location
  (fn [[_ qpe-identity]]
    (subscribe [:current-project/tag-locations qpe-identity]))
  (fn [locations-map [_id _qpe-identity tag-id]]
    (get locations-map tag-id)))

(reg-sub
  :current-project/tag-position
  (fn [[_ qpe-identity tag-id]]
    (subscribe [:current-project/tag-location qpe-identity tag-id]))
  (fn [tag-location-map [_id _qpe-identity _tag-id]]
    (:position tag-location-map)))

(reg-sub
  :current-project/state
  (fn sub-current-project-state
    [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :project-state])))

(reg-sub
  :current-project/locator-status
  (fn sub-current-project-locator-state
    [db [_ qpe-identity]]
    ;; derived info, adapted logic from QuuppaServerController.getLocatorStatus
    (let [{pe-mode :target-mode
           :keys [pe-running? simulator-mode?]}
          (get-in db [:qpes qpe-identity :controller-state])

          {:keys [runtime-locator-count runtime-locator-ok-count project-locator-count project-locator-ok-count
                  old-fw-locator-count project-locator-about-to-expire-count moved-locator-count]}
          (get-in db [:qpes qpe-identity :project-state])

          status-ratio (str project-locator-ok-count "/" project-locator-count)]
      (cond
        (not pe-running?) ["-" nil]
        simulator-mode? ["-" nil]
        (not= pe-mode :Normal) [(+ project-locator-ok-count runtime-locator-ok-count) nil]
        :else (cond
                (> moved-locator-count 0) [status-ratio (str "(" moved-locator-count " Locators moved)")]
                (> runtime-locator-count 0) [status-ratio (str ", also " runtime-locator-count " Locators that are not in project")]
                (> old-fw-locator-count 0) [status-ratio (str ", " old-fw-locator-count " locators running old firmware.")]
                (> project-locator-ok-count 0) [status-ratio nil]
                :else ["-" nil])))))

(reg-sub
  :current-project/locator-channels
  (fn sub-current-project-locator-channels
    [db [_ qpe-identity]]
    ;; derived info, adapted logic from QuuppaServerController.getLocatorChannels
    (let [pe-running? (get-in db [:qpes qpe-identity :controller-state :pe-running?])
          pe-mode (get-in db [:qpes qpe-identity :controller-state :target-mode])
          deployment-locator-count (get-in db [:qpes qpe-identity :project-state :deployment-locator-count])
          locator-count-by-channel (get-in db [:qpes qpe-identity :project-state :locator-count-by-channel])
          ;;moved-locator-count (get-in db [:project-state :moved-locator-count])
          locator-channel-count-strs (keep (fn [[k v]]
                                             (when-let [s (utils/channel->pretty-string k)]
                                               (str s
                                                    " (" v " Locator" (when (> v 1) "s") ")")))
                                           locator-count-by-channel)
          deployment-locator-count-str (when (> deployment-locator-count 0)
                                         (str "Deployment (" deployment-locator-count " Locator"
                                              (when (> deployment-locator-count 1)
                                                "s")
                                              ")"))]
      (cond
        (not pe-running?) "-"
        (not= pe-mode :Normal) "-"
        :else (str (s/join ", " locator-channel-count-strs)
                   (when (and (seq locator-channel-count-strs)
                              deployment-locator-count-str)
                     ", ")
                   deployment-locator-count-str)))))

(rf/reg-sub
  :qpe/position-events
  (fn [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :position-events])))

(rf/reg-sub
  :qsm/siteresource
  (fn [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :siteresource])))

(rf/reg-sub
  :qpe/filtered-output-data-files
  (fn [[_ qpe-identity _search-string]]
    [(rf/subscribe [:qpe/output-data-files-metadata qpe-identity])])
  (fn [[files] [_ _qpe-identity search-string]]
    (pe-utils/filter-output-data-files search-string files)))

